const useUpdateClientProfileDto = (
  options?: GraphqlMutationOptions<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>,
) => {
  const mutation = useGraphqlMutation(UpdateClientProfileSchema, options);

  return {
    ...mutation,
  };
};

export { useUpdateClientProfileDto };
